import PremiumIcon from "assets/images/components/PremiumIcon";
import ContentBox from "components/ContentBox";
import Table from "components/Table";
import TitleSection from "components/TitleSection";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getPremiumLadder } from "utils/api";
import { PERCENTAGE } from "components/Table/columnFormat";


const TablesPremiumLadder = () => {
  const { t } = useTranslation();
  const [premiumLadder, setPremimumLadder] = useState();
  const columns = [
    { label: t("age"), accessor: "age", sortable: true },
    { label: t("percentage_age"), accessor: "percentage_age", format: PERCENTAGE},
  ];
  useEffect(() => { getPremiumLadder().then(t => setPremimumLadder(t)) }, [])
  return (
    <ContentBox>
      <TitleSection title={t("tables.premium-ladder.title")} Icon={PremiumIcon} />
      {premiumLadder && <Table data={premiumLadder} columns={columns} />}
    </ContentBox>

  );
};

export default TablesPremiumLadder;
